import {getTelCode, getRegister, getEmailCode,getLogin,logout,loginNum} from "../../api/login";
import {getUserInfo} from "../../api/user";
import Cook from "../../common/cookie";
import Cookies from "js-cookie";
import {Message} from "element-ui";
import {language} from "../../language/get";
import {tickUrl} from "../../common/url";
import getParams from "../../common/util";

const type = getParams.getQueryString("type");
const exhibitionId = getParams.getQueryString("exhibitionId");

const lang = language();
const state = {
  telCode: null,  //手机号
  emailCode: null, //邮箱,
  token: Cook.get("token") || null, //用户信息token
  userInfo: getCookies() || {}, //用户信息
};
const mutations = {
  SET_CODE: (state, telCode) => {
    state.telCode = telCode;
  },
  SET_TOKEN: (state, token) => {
    if (token != null || token != undefined) {
      state.token = token;
      Cook.set("token", token)
    }
  },

  DEL_TOKEN: (state) => {
    state.token = null;
    state.userInfo = {};
  },

  SET_EMAIL: (state, emailCode) => {
    state.emailCode = emailCode;
  },

  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
    Cookies.set("user", JSON.stringify(userInfo))
  },
};

const actions = {
  //获取验证码
  getCode({commit}, telCode) {
    return new Promise((resolve, reject) => {
      getTelCode(telCode).then(res => {
        commit("SET_CODE", res);
        resolve(res)
      }).catch(err => reject(err))
    })
  },
  //注册用户
  async getRegister({commit,  dispatch}, userInfo) {
    const token = await handleReg(userInfo);
    const userDet = await getUserDetails(token);
    commit("SET_TOKEN", token);
    commit("SET_USERINFO", userDet);
    if (type != null &&
      exhibitionId != null
      && type != undefined
      && exhibitionId != undefined
      &&
      type != "undefined" &&
      exhibitionId != "undefined"
    ) {
      return window.location.href = tickUrl(type,exhibitionId);
    }
    const referrer = document.referrer;
    const origin = window.location.protocol + "//" + window.location.host;
    const url = referrer.substring(origin.length);
    if (url.indexOf("/login.html") == -1 && url.indexOf("/register.html") == -1 && url != null && url != undefined && url != "undefined" && url != "") {
      window.history.go(-1);
    }else {
      window.location.href  = "index.html";
    }
  },
  //获取邮箱验证码
  getEmail({commit}, email) {
    return new Promise((resolve, reject) => {
      getEmailCode(email).then(res => {
        commit("SET_EMAIL", res);
        resolve(res);
      }).catch(err => {reject(err)})
    })
  },
  //用户登录
  async getInfo({commit, dispatch}, userInfo) {
    const token = await login(userInfo);
    const userDet = await getUserDetails(token);
    commit("SET_TOKEN", token);
    commit("SET_USERINFO", userDet);
    if (type != null &&
      exhibitionId != null
      && type != undefined
      && exhibitionId != undefined
      &&
      type != "undefined" &&
      exhibitionId != "undefined"
    ){
      return window.location.href = tickUrl(type,exhibitionId);
    }
    const referrer = document.referrer;
    const origin = window.location.protocol + "//" + window.location.host;
    const url = referrer.substring(origin.length);
    if (url.indexOf("/login.html") == -1 && url.indexOf("/register.html") == -1 && url != null && url != undefined && url != "undefined" && url != "") {
      window.history.go(-1);
    }else {
      window.location.href  = "index.html";
    }
  },

  //票号登录
  async banksLogin({commit,dispatch}, userInfo) {
    const token = await loginNumber(userInfo);
    const userDet = await getUserDetails(token);
    commit("SET_TOKEN", token);
    commit("SET_USERINFO", userDet);
    const referrer = document.referrer;
    const origin = window.location.protocol + "//" + window.location.host;
    const url = referrer.substring(origin.length);
    if (url.indexOf("/login.html") == -1 && url.indexOf("/register.html") == -1 && url != null && url != undefined && url != "undefined" && url != "") {
      window.history.go(-1);
    }else {
      window.location.href  = "index.html";
    }
  },

  //用户退出
  Logout({commit}, token) {
    return new Promise((resolve, reject) => {
      logout(token).then(res => {
        if (res.type== "1") {
          commit("DEL_TOKEN", null);
        }
        Cook.del("token");
        Cookies.remove("user");
        Cookies.remove("sign");
        resolve(res)
      }).catch(err => {reject(err)})
    })
  }

};

var lan = Cook.get("lang");

function login(userInfo) {
  return new Promise((resolve, reject) => {
    getLogin(userInfo).then(res => {
      if (res.type == "1") {
        Message.success({
          message: lang.loginSuccess,
          offset: 120,
          duration: 5000
        });
        resolve(res.data.token);
        return;
      }
      if (lan=="ch"){
        return Message.error({
          message: res.text,
          offset: 120
        })
      }else {
        return Message.error({
          message: res.text_en,
          offset: 120
        })
      }
    }).catch(err => reject(err))
  })
}
function getUserDetails(token) {
  return new Promise((resolve, reject) => {
    getUserInfo({token: token}).then(res => {
      if (res.type == "1") {
        resolve(res.data[0]);
        return
      }
      if (lan=="ch"){
        return Message.error({
          message: res.text,
          offset: 120
        })
      }else {
        return Message.error({
          message: res.text_en,
          offset: 120
        })
      }
    }).catch(err => reject(err))
  })
}
function loginNumber(userInfo) {
  return new Promise((resolve, reject) => {
    loginNum(userInfo).then(res => {
      if (res.type == "1") {
        Message.success({
          message: lang.loginSuccess,
          offset: 120,
          duration: 5000
        });
        resolve(res.data.token);
        return;
      }
      if (lan=="ch"){
        return Message.error({
          message: res.text,
          offset: 120
        })
      }else {
        return Message.error({
          message: res.text_en,
          offset: 120
        })
      }
    }).catch(err => reject(err));
  })
}
function handleReg(userInfo) {
  return new Promise((resolve, reject) => {
    getRegister(userInfo).then(res => {
      if (res.type == '1') {
        Message.success({
          message: lang.registerSuccess,
          offset: 120,
          duration: 5000
        });
        resolve(res.data.token);
        return;
      }
      if (lan=="ch"){
        return Message.error({
          message: res.text,
          offset: 120
        })
      }else {
        return Message.error({
          message: res.text_en,
          offset: 120
        })
      }

    }).catch(err => reject(err))
  })
}

function getCookies() {
  let user =  Cookies.get("user");
  if(!user||user==null||user=="undefined"){
    Cook.del("token");
    return {}
  }else {
    return JSON.parse(user);
  }
}
export default {
  state,
  mutations,
  actions
}
